import React from "react";

const copyright = () => {
  return (
    <div className="bg-dark text-light font-ubuntu py-3">
      <h1>© 2023 PK Smedeservice. Alle rettigheder forbeholdes</h1>
    </div>
  );
};

export default copyright;
